import React, { useState, useEffect } from 'react';
import Masonry from 'react-masonry-css';

import { ITileGridFields } from '../../../types/contentful';

import { breakpoints } from '../../styles/media-queries';

import { QuickStartGuideBox } from '../QuickStartGuideBox';
import { BlockContainer, Layout, BoxColumn } from '../Layout';

import {
  MasonryWrapper,
  MASONRY_CLASS,
  MASONRY_COL_CLASS
} from '../MasonryWrapper';

export function TileGrid({ boxes }: ITileGridFields) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(
      typeof window !== `undefined` && window.innerWidth < breakpoints.tablet
    );
  }, []);

  return (
    <BlockContainer
      marginTop={{
        0: 0,
        tablet: 'blockMarginY_tablet'
      }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-blockid="tile-grid"
      data-testid="tile-grid"
    >
      <Layout>
        <BoxColumn
          size={{ 0: 12, desktop: 10 }}
          paddingTop={{ 0: 0, desktop: 'xs' }}
        >
          {isMobile ? (
            (boxes || []).map(({ sys, fields }) => (
              <QuickStartGuideBox {...fields} key={sys.id} />
            ))
          ) : (
            <MasonryWrapper>
              <Masonry
                breakpointCols={2}
                className={MASONRY_CLASS}
                columnClassName={MASONRY_COL_CLASS}
              >
                {(boxes || []).map(({ sys, fields }) => (
                  <QuickStartGuideBox {...fields} key={sys?.id} />
                ))}
              </Masonry>
            </MasonryWrapper>
          )}
        </BoxColumn>
      </Layout>
    </BlockContainer>
  );
}
